import script from "./ResultTypeSettingsPlug.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultTypeSettingsPlug.vue?vue&type=script&setup=true&lang=js"

import "./ResultTypeSettingsPlug.vue?vue&type=style&index=0&id=2eb3802c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eb3802c"]])

export default __exports__